











































































import { defineComponent, PropType } from '@vue/composition-api';

import HeadingCenter from '@/components/molecules/HeadingCenter.vue';

import AtomButton from '@/components/atoms/AtomButton.vue';
import AtomDivider from '@/components/atoms/AtomDivider.vue';
import WrapperCard from '@/components/atoms/WrapperCard.vue';

import { useDocumentDescription } from '@/modules/advisor-search/utils/useDocumentDescription';
import { useDocumentTitle } from '@/modules/advisor-search/utils/useDocumentTitle';
import { useExpertDomain } from '@/helpers/provideExpertDomain';
import AdvisorSearchForm from '@/modules/advisor-search/organisms/AdvisorSearchForm/AdvisorSearchForm.vue';
import AdvisorSearchRecommendedKeywords from '@/modules/advisor-search/organisms/AdvisorSearchRecommendedKeywords.vue';

export default defineComponent({
  name: 'AdvisorSearchRequestPage',
  components: {
    HeadingCenter,

    AtomButton,
    AtomDivider,
    WrapperCard,

    AdvisorSearchForm,
    AdvisorSearchRecommendedKeywords,
  },
  props: {
    userId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    recommendedKeywords: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup() {
    useDocumentDescription(() => '');
    useDocumentTitle(() => 'エキスパートを探す');
    return {
      expertDomain: useExpertDomain(),
    };
  },
});
